export default __webpack_public_path__ + "static/media/litho-inner-page-slider-05.cd805652.jpg";